exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ant-table-fixed-header .ant-table-scroll .ant-table-header {\n  margin-bottom: 0px !important;\n  padding-bottom: 0px !important;\n  overflow: hidden !important;\n  opacity: 0.9999;\n  padding-right: 8px;\n}\n", ""]);

// exports
